export const SelectImages = {
  DEFAULT: 'default',
  LOW_SATURATION: 'lowSaturation',
};
